<template>

  <vs-row>
    <vs-col>
      <vs-row>
        <vs-input
          class="inputx w-full"
          label="Name"
          placeholder="Customer name"
          type="text"
          v-model="bookingCustomer.name"
          :danger="!validBookingCustomerInfo"
          danger-text="Name, email and phone number must all provided if not all are empty"
          @change="$emit('booking-customer-updated', bookingCustomer)"
          :disabled="disableComponent"
        />
      </vs-row>
      <vs-row class="mt-2">
        <vs-input
          class="inputx w-full"
          label="Email"
          placeholder="Customer email"
          type="text"
          v-model="bookingCustomer.email"
          :danger="!validBookingCustomerInfo"
          danger-text="Name, email and phone number must all provided if not all are empty"
          @change="$emit('booking-customer-updated', bookingCustomer)"
          :disabled="disableComponent"
        />
      </vs-row>
      <vs-row class="mt-2">
        <vs-input
          class="inputx w-full"
          label="Phone number"
          placeholder="Customer phone number"
          type="text"
          v-model="bookingCustomer.phoneNumber"
          :danger="!validBookingCustomerInfo"
          danger-text="Name, email and phone number must all provided if not all are empty"
          @change="$emit('booking-customer-updated', bookingCustomer)"
          :disabled="disableComponent"
        />
      </vs-row>

      <vs-row class="mt-2" v-if="bookingCustomer.company">
        <vs-input
          class="inputx w-full"
          label="Company name"
          placeholder="Company name"
          type="text"
          v-model="bookingCustomer.company"
          danger-text="Name, email and phone number must all provided if not all are empty"
          @change="$emit('booking-customer-updated', bookingCustomer)"
          :disabled="true"
        />
      </vs-row>

      <vs-row class="mt-2" v-if="bookingCustomer.vatNo">
        <vs-input
          class="inputx w-full"
          label="VAT no"
          placeholder="VAT no"
          type="text"
          v-model="bookingCustomer.vatNo"
          danger-text="Name, email and phone number must all provided if not all are empty"
          @change="$emit('booking-customer-updated', bookingCustomer)"
          :disabled="true"
        />
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>

export default {
  components: {
  },
  props: {
    bookingCustomer: Object,
    disableComponent: Boolean
  },
  model: {
    prop: 'bookingCustomer',
    event: 'booking-customer-updated'
  },
  data() {
    return {
    };
  },
  computed: {
    validBookingCustomerInfo() {
      return (
        this.bookingCustomer && this.bookingCustomer.isValid()
      );
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
